import * as actions from './actions'
import mutations from './mutations'
import * as getters from './getters'

const MonthlyStates = {
  namespaced: true,
  state: {
    businessesMonthlyStates: [],
    lastLocalUpdate: null, // Timestamp de la última actualización local
    pendingUpdates: 0 // Contador de actualizaciones pendientes
  },
  getters,
  mutations,
  actions
}

export default MonthlyStates